<!-- src/components/Inventario/Reportes/ConsumoMateriaPrima/components/CMPSelectorPeriodo.vue -->
<template>
  <div class="cmp-selector">
    <!-- Periodo A -->
    <div class="cmp-selector__periodo">
      <div class="cmp-selector__grupo">
        <label class="cmp-selector__label">Periodo A</label>
        <div class="cmp-selector__rango">
          <div class="cmp-selector__input-fecha">
            <input
              type="date"
              v-model="localA.fecha_inicio"
              :max="localA.fecha_fin || undefined"
              @change="emitirA"
            />
          </div>
          <div class="cmp-selector__input-fecha">
            <input
              type="date"
              v-model="localA.fecha_fin"
              :min="localA.fecha_inicio || undefined"
              @change="emitirA"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Periodo B -->
    <div class="cmp-selector__periodo">
      <div class="cmp-selector__grupo">
        <label class="cmp-selector__label">Periodo B</label>
        <div class="cmp-selector__rango">
          <div class="cmp-selector__input-fecha">
            <input
              type="date"
              v-model="localB.fecha_inicio"
              :max="localB.fecha_fin || undefined"
              @change="emitirB"
            />
          </div>
          <div class="cmp-selector__input-fecha">
            <input
              type="date"
              v-model="localB.fecha_fin"
              :min="localB.fecha_inicio || undefined"
              @change="emitirB"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch } from "vue";

const props = defineProps({
  periodoA: { type: Object, required: true }, // { fecha_inicio, fecha_fin }
  periodoB: { type: Object, required: true },
});

const emit = defineEmits(["update:periodoA", "update:periodoB"]);

const localA = reactive({ ...props.periodoA });
const localB = reactive({ ...props.periodoB });

watch(
  () => props.periodoA,
  (v) => Object.assign(localA, v)
);
watch(
  () => props.periodoB,
  (v) => Object.assign(localB, v)
);

const MESES = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

/**
 * Formatea una fecha ISO ('2026-01-05') a 'dd mes' sin pasar por objetos
 * Date (evita el corrimiento de un día por zona horaria al usar new Date()
 * con un string 'YYYY-MM-DD', que JS interpreta como UTC medianoche).
 */
function formatearDia(fechaIso) {
  const [, mes, dia] = fechaIso.split("-").map(Number);
  return `${dia} ${MESES[mes - 1]}`;
}

function etiquetaRango(fecha_inicio, fecha_fin) {
  if (!fecha_inicio || !fecha_fin) return "";
  if (fecha_inicio > fecha_fin) return "Rango inválido";
  const anio = fecha_fin.split("-")[0];
  return `${formatearDia(fecha_inicio)} – ${formatearDia(fecha_fin)} ${anio}`;
}

function emitirA() {
  if (
    localA.fecha_inicio &&
    localA.fecha_fin &&
    localA.fecha_inicio <= localA.fecha_fin
  ) {
    emit("update:periodoA", { ...localA });
  }
}
function emitirB() {
  if (
    localB.fecha_inicio &&
    localB.fecha_fin &&
    localB.fecha_inicio <= localB.fecha_fin
  ) {
    emit("update:periodoB", { ...localB });
  }
}
</script>

<style scoped>
/* Input de fecha */
.cmp-selector__input-fecha {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d8d2c4;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.cmp-selector__input-fecha input[type="date"] {
  padding: 0.4rem 0.5rem;
  border: none;
  outline: none;
  font-size: 0.82rem;
  color: #2c2a24;
  background: #fff;
  cursor: pointer;
}

.cmp-multiselect {
  position: relative;
}

.cmp-multiselect__btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  min-width: 200px;
  padding: 0.45rem 0.7rem;
  border: 1px solid #d8d2c4;
  border-radius: 6px;
  background: #fff;
  font-size: 0.85rem;
  color: #2c2a24;
  cursor: pointer;
}

.cmp-multiselect__caret {
  font-size: 0.7rem;
  color: #8a8270;
  transition: transform 0.15s ease;
}
.cmp-multiselect__caret--abierto {
  transform: rotate(180deg);
}

.cmp-multiselect__panel {
  position: absolute;
  z-index: 20;
  top: calc(100% + 0.3rem);
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #d8d2c4;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  padding: 0.4rem;
}

.cmp-multiselect__opcion {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.4rem;
  font-size: 0.83rem;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
}
.cmp-multiselect__opcion:hover {
  background: #faf6ec;
}
.cmp-multiselect__opcion--todas {
  border-bottom: 1px solid #ece7da;
  margin-bottom: 0.3rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.cmp-multiselect__lista {
  max-height: 170px;
  overflow-y: auto;
}

.cmp-multiselect__vacio {
  font-size: 0.8rem;
  color: #999;
  padding: 0.4rem;
}
</style>
